export { default } from './ActivityGroupConnected'